// The CommandBar in @fluentui/react-experiments has 'graduated'.
// Consumer projects should switch to using the version from '@fluentui/react' before Fabric 7.
export { CommandBar, CommandBarBase } from '@fluentui/react/lib/CommandBar';
export type {
  ICommandBar,
  ICommandBarData,
  ICommandBarItemProps,
  ICommandBarProps,
  ICommandBarStyleProps,
  ICommandBarStyles,
} from '@fluentui/react/lib/CommandBar';
